module.exports = __webpack_public_path__ + "unknown-device@2x.2c67cc8b770105c89c9c7ffb0787e814.png";